import { atom } from "jotai";

export const isAgentsEnabledAtom = atom<boolean>(false);
isAgentsEnabledAtom.debugLabel = "isAgentsEnabledAtom";
